import { useErrorStore } from '~/stores/useErrorStore'

/** Page error state controls for components that render the error. */
export const usePageErrorState = (): { clearError: () => void } => {
  const store = useErrorStore()
  return {
    clearError: () => {
      store.clearError()
    }
  }
}
